export default __webpack_public_path__ + "static/media/logo_black.0b4d62bf.jpg";